import { Controller } from "@hotwired/stimulus"

// Kosten form: typing Netto pre-fills Brutto at the tenant's default VAT rate, until the
// user types into Brutto themselves. Brutto is never derived on the server — rows exist
// where it equals Netto (MwSt + Selbstbeteiligung), so the user always has the last word.
export default class extends Controller {
  static targets = ["net", "gross"]
  static values = { rate: Number }

  connect() {
    // A saved or re-rendered entry already carries a Brutto of its own; leave it alone.
    this.grossTouched = this.grossTarget.value.trim() !== ""
  }

  netChanged() {
    if (this.grossTouched) return

    const net = parseGermanNumber(this.netTarget.value)
    this.grossTarget.value =
      net === null ? "" : formatGermanNumber(Math.round(net * (100 + this.rateValue)) / 100)
  }

  grossChanged() {
    this.grossTouched = this.grossTarget.value.trim() !== ""
  }
}

// Same rules as AssetCost.parse_amount: "1.234,50" → 1234.5; "1.500" → 1500 (dots grouping
// digits in threes are thousands separators); "1234.5" → 1234.5.
const THOUSANDS_GROUPED = /^-?\d{1,3}(\.\d{3})+$/

export function parseGermanNumber(raw) {
  const value = raw.trim().replace(/[\s€]/g, "")
  if (value === "") return null

  const german = value.includes(",") || THOUSANDS_GROUPED.test(value)
  const normalized = german ? value.replace(/\./g, "").replace(",", ".") : value
  return /^-?\d+(\.\d+)?$/.test(normalized) ? Number(normalized) : null
}

export function formatGermanNumber(number) {
  return number.toFixed(2).replace(".", ",")
}
